import * as React from 'react';

import { AbsoluteCenter, Button as ChakraButton, Span, Spinner } from '@chakra-ui/react';

import type { ButtonProps as ChakraButtonProps } from '@chakra-ui/react';

/** Sizes defined on `buttonRecipe` in theme.ts — keep in sync. */
export type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';

interface ButtonLoadingProps {
  loading?: boolean;
  loadingText?: React.ReactNode;
}

export interface ButtonProps extends Omit<ChakraButtonProps, 'size'>, ButtonLoadingProps {
  /** Figma Selected (ghost). Sets `aria-pressed` for toggle styling. */
  selected?: boolean;
  size?: ButtonSize;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { loading, disabled, loadingText, selected, children, ...rest } = props;
  return (
    <ChakraButton
      data-testid={`button-${props.variant}`}
      disabled={loading || disabled}
      aria-pressed={selected || undefined}
      ref={ref}
      {...rest}
    >
      {/* eslint-disable-next-line no-nested-ternary */}
      {loading && !loadingText ? (
        <>
          <AbsoluteCenter display="inline-flex">
            <Spinner size="inherit" color="inherit" />
          </AbsoluteCenter>
          <Span opacity={0}>{children}</Span>
        </>
      ) : loading && loadingText ? (
        <>
          <Spinner size="inherit" color="inherit" />
          {loadingText}
        </>
      ) : (
        children
      )}
    </ChakraButton>
  );
});
